import type { Placement } from "react-joyride";

export interface TourStepDef {
	id: string;
	target: string;
	titleKey: string;
	bodyKey: string;
	route?: string;
	placement?: Placement | "center";
	disableBeacon?: boolean;
	mobileTarget?: string;
}

export const buildTourSteps = (): TourStepDef[] => [
	{
		id: "welcome",
		target: "body",
		titleKey: "tour.steps.welcome.title",
		bodyKey: "tour.steps.welcome.body",
		route: "/",
		placement: "center",
		disableBeacon: true,
	},
	{
		id: "sidebar",
		target: '[data-tour="nav-candidates"]',
		titleKey: "tour.steps.sidebar.title",
		bodyKey: "tour.steps.sidebar.body",
		route: "/",
		placement: "right",
		disableBeacon: true,
		mobileTarget: '[data-tour="mobile-menu-toggle"]',
	},
	{
		id: "dashboardQuickActions",
		target: '[data-tour="dashboard-quick-actions"]',
		titleKey: "tour.steps.dashboardQuickActions.title",
		bodyKey: "tour.steps.dashboardQuickActions.body",
		route: "/",
		placement: "left",
		disableBeacon: true,
	},
	{
		id: "candidatesSearch",
		target: '[data-tour="candidates-search"]',
		titleKey: "tour.steps.candidatesSearch.title",
		bodyKey: "tour.steps.candidatesSearch.body",
		route: "/candidates",
		placement: "bottom",
		disableBeacon: true,
	},
	{
		id: "candidatesAdd",
		target: '[data-tour="candidates-add"]',
		titleKey: "tour.steps.candidatesAdd.title",
		bodyKey: "tour.steps.candidatesAdd.body",
		route: "/candidates",
		placement: "bottom",
		disableBeacon: true,
	},
	{
		id: "candidatesBulkImport",
		target: '[data-tour="candidates-bulk-import"]',
		titleKey: "tour.steps.candidatesBulkImport.title",
		bodyKey: "tour.steps.candidatesBulkImport.body",
		route: "/candidates",
		placement: "bottom",
		disableBeacon: true,
	},
	{
		id: "jobsAdd",
		target: '[data-tour="jobs-add"]',
		titleKey: "tour.steps.jobsAdd.title",
		bodyKey: "tour.steps.jobsAdd.body",
		route: "/jobs",
		placement: "bottom",
		disableBeacon: true,
	},
	{
		id: "jobDetailProfile",
		target: '[data-tour="job-profile-info"]',
		titleKey: "tour.steps.jobDetailProfile.title",
		bodyKey: "tour.steps.jobDetailProfile.body",
		route: "/jobs/:jobId",
		placement: "bottom",
		disableBeacon: true,
	},
	{
		id: "jobDetailProcess",
		target: '[data-tour-tab="process"]',
		titleKey: "tour.steps.jobDetailProcess.title",
		bodyKey: "tour.steps.jobDetailProcess.body",
		route: "/jobs/:jobId",
		placement: "bottom",
		disableBeacon: true,
	},
	{
		id: "jobDetailPublish",
		target: '[data-tour="job-publish-indicator"]',
		titleKey: "tour.steps.jobDetailPublish.title",
		bodyKey: "tour.steps.jobDetailPublish.body",
		route: "/jobs/:jobId",
		placement: "bottom",
		disableBeacon: true,
	},
	{
		id: "matchesScore",
		target: '[data-tour="matches-score-filter"]',
		titleKey: "tour.steps.matchesScore.title",
		bodyKey: "tour.steps.matchesScore.body",
		route: "/matches",
		placement: "bottom",
		disableBeacon: true,
	},
	{
		id: "matchesCard",
		target: '[data-tour="match-card"]',
		titleKey: "tour.steps.matchesCard.title",
		bodyKey: "tour.steps.matchesCard.body",
		route: "/matches",
		placement: "right",
		disableBeacon: true,
	},
	{
		id: "matchDetailScore",
		target: '[data-tour="match-score-breakdown"]',
		titleKey: "tour.steps.matchDetailScore.title",
		bodyKey: "tour.steps.matchDetailScore.body",
		route: "/matches/:matchId",
		placement: "top",
		disableBeacon: true,
	},
	{
		id: "matchDetailTimeline",
		target: '[data-tour="match-timeline"]',
		titleKey: "tour.steps.matchDetailTimeline.title",
		bodyKey: "tour.steps.matchDetailTimeline.body",
		route: "/matches/:matchId",
		placement: "bottom",
		disableBeacon: true,
	},
	{
		id: "kanban",
		target: '[data-tour="kanban-board"]',
		titleKey: "tour.steps.kanban.title",
		bodyKey: "tour.steps.kanban.body",
		route: "/kanban",
		placement: "top",
		disableBeacon: true,
	},
	{
		id: "notifications",
		target: '[data-tour="notification-bell"]',
		titleKey: "tour.steps.notifications.title",
		bodyKey: "tour.steps.notifications.body",
		route: "/",
		placement: "bottom",
		disableBeacon: true,
	},
	{
		id: "userMenu",
		target: '[data-tour="user-menu"]',
		titleKey: "tour.steps.userMenu.title",
		bodyKey: "tour.steps.userMenu.body",
		route: "/",
		placement: "right",
		disableBeacon: true,
	},
];

export const resolveTarget = (step: TourStepDef, isMobile: boolean): string => {
	if (isMobile && step.mobileTarget)
		return step.mobileTarget;
	return step.target;
};
